import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import InputIdVoucherPromoItems from "../../components/commons/promo/InputIdVoucherPromoItems";

function PromoModal({ show, toggle, type, action, data, register, outlet }) {

    const title = type === "add" ? "Tambah Promo" : "Upload ID Promo"

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}>
                <ModalHeader className="text-extra-bold pt-5"> {title} <span className="close clickable click-in-right" onClick={toggle}>&times;</span></ModalHeader>
                {/* <p className="desc-title-form">Isi form berikut untuk mengedit promo</p> */}
                

                <ModalBody>
                    <InputIdVoucherPromoItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                        outlet={outlet}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default PromoModal
